import React from 'react'
import { Skeleton } from '@material-ui/lab'

import * as S from './../templateItem.styles'

export const TemplateItemSkeleton = () => {
    return (
        <S.TemplateItemWrapper>
            <S.Title>
                <Skeleton width={240} />
                <Skeleton width={240} />
            </S.Title>

            <S.Description>
                <Skeleton width={120} />
            </S.Description>
        </S.TemplateItemWrapper>
    )
}
